import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Verification {
  private http = inject(HttpClient);
  constructor() { }

  postVerificationForm(form: any) {
    return this.http.post(`${environment.apiUrl}/verification/createRequest`, form)
      .pipe(catchError(this.errorHandle))
  }

  updateVerificationForm(form: any, id: any,confirmFail:boolean) {
    return this.http.patch(`${environment.apiUrl}/verification/request/${id}?`, form)
      .pipe(catchError(this.errorHandle))
  }

  getVerificationList(rowNum: number, size: number, status: string, requestorName: string, type: string,companyName:string) {
    return this.http.get(`${environment.apiUrl}/verification/request/list?rowNum=${rowNum}&size=${size}&status=${status}&requestorName=${requestorName}&type=${type}&companyName=${companyName}`)
      .pipe(catchError(this.errorHandle))
  }

  getAuditQueue(rowNum: number, size: number, status: string, country: string, companyName: string, sortOrder: string) {
    return this.http.get(`${environment.apiUrl}/verification/audit?rowNum=${rowNum}&size=${size}&status=${status}&country=${country}&companyName=${companyName}&sortOrder=${sortOrder}`)
      .pipe(catchError(this.errorHandle))
  }

  getVerificationById(id: string) {
    return this.http.get(`${environment.apiUrl}/verification/request/${id}`)
      .pipe(catchError(this.errorHandle))
  }

  postCanonForm(sourceRequestId:any,form: any) {
    return this.http.post(`${environment.apiUrl}/verification/company?sourceReuqestId=${sourceRequestId}`, form)
      .pipe(catchError(this.errorHandle))
  }

  patchCanonForm(id: any, form: any) {
    return this.http.patch(`${environment.apiUrl}/verification/canon/${id}`, form)
      .pipe(catchError(this.errorHandle))
  }

  getCanonList(rowNum: number, size: number, companyName: string, easyNumber:string,type: string, country: string) {
    return this.http.get(`${environment.apiUrl}/verification/company/list?rowNum=${rowNum}&size=${size}&companyName=${companyName}&easyNumber=${easyNumber}&type=${type}&country=${country}`)
      .pipe(catchError(this.errorHandle))
  }

  getCanonSearchList(companyName: string, country: string, companyType: string) {
    return this.http.get(`${environment.apiUrl}/verification/canon/like?companyName=${companyName}&country=${country}&companyType=${companyType}`)
      .pipe(catchError(this.errorHandle))
  }

  deleteCanonRecord(id: string) {
    return this.http.delete(`${environment.apiUrl}/verification/canon/${id}`)
      .pipe(catchError(this.errorHandle))
  }

  patchAuditRequest(requestId: string, status: string, confirmFail: string, providedCanonId: string, formData: any) {
    return this.http.patch(`${environment.apiUrl}/verification/audit/request/${requestId}?status=${status}&confirmFail=${confirmFail}&providedCanonId=${providedCanonId}`, formData).pipe(catchError(this.errorHandle))
  }
  patchVerificationRequest(id:string, form:any){
    return this.http.patch(`${environment.apiUrl}/verification/request/${id}`,form)
  }

  getVerificationHistory(rowNum: number, size: number, country: string, companyName: string, requestSuccessful: string) {
    return this.http.get(`${environment.apiUrl}/verification/history?rowNum=${rowNum}&size=${size}&country=${country}&companyName=${companyName}&requestSuccessful=${requestSuccessful}`)
      .pipe(catchError(this.errorHandle))
  }

  getVerificationHistoryById(requestId: any) {
    return this.http.get(`${environment.apiUrl}/verification/history/request/${requestId}`)
      .pipe(catchError(this.errorHandle))
  }

  linkToExistingCompany(newCompanyId:string,existingCompanyId:string){
    return this.http.post(`${environment.apiUrl}/verification/request/${newCompanyId}/copy-coface/${existingCompanyId}`, {})
      .pipe(catchError(this.errorHandle))
  }

  errorHandle(error: any) {
    let errorMessage = "";
    if (error.error.error instanceof ErrorEvent) {
      errorMessage = error.error.error;
    } else {
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
